import React from 'react'
import Helmet from 'react-helmet'
import NotFoundView from './NotFound.Component.jsx'

export default class NotFound extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Helmet title="Page Not Found" />
        <NotFoundView />
      </React.Fragment>
    )
  }
}

NotFound.displayName = 'NotFound'
